import { Center } from "./Center";
import { Loader } from "./Loader";


export class CenteredLoader extends Center
{
    constructor(text: string = "Ładowanie...")
    {
        super();
        this.Margin(32)

        this.Append(
            new Loader(text)
        )
    }
}
